import { useCurrentAddressInfo } from '@/hooks';
import { request } from '@/utils';
import dayjs from 'dayjs';
import { useQuery } from 'react-query';
import { atom, useRecoilState } from 'recoil';

export type Issue = {
  id: number;
  status: 'ongoing' | 'ended' | 'not start';
  start_at: number;
  end_at: number;
  _endTime: string;
  duration: string;
};

const select = (res: { issues: Issue[] }) => {
  return res?.issues?.map(i => {
    return {
      ...i,
      _endTime: dayjs.unix(i.end_at).utc().format('MMMM D HH:mm:ss'),
      duration: `${dayjs.unix(i.start_at).utc().format('MMMM D, YYYY')} - ${dayjs.unix(i.end_at).utc().format('MMMM D, YYYY')}`,
    };
  });
};

export const usePrimePostIssues = ({ enabled }: { enabled: boolean }) => {
  const url = '/article/prime_post_issues';
  const { address } = useCurrentAddressInfo();
  return useQuery([url], () => request.get<{ issues: Issue[] }>(url), {
    select,
    enabled: !!address && enabled,
  });
};

const CurrentPrimeIssueIdAtom = atom({
  key: 'CurrentPrimeIssueId',
  default: '',
});

export const useCurrentPrimeIssueId = () => {
  const [primeIssueId, setPrimeIssueId] = useRecoilState(CurrentPrimeIssueIdAtom);
  return { primeIssueId, setPrimeIssueId };
};
